import { Box, Theme, useMediaQuery, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DesktopLoginBg, dskLogo, LoginBg, Logo } from "../../Assets";
import { ReactChildren } from "../../interfaces/Common";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100dvh",
    width: "100%",
    position: "relative",
    backgroundColor: "#101010",
    fontFamily: "Schibsted Grotesk !important",
    backgroundImage: `url(${LoginBg}) !important`,
    backgroundSize: "cover",
    overflow: "hidden",
  },
  desktopLayout: {
    height: "100vh",
    position: "relative",
  },
  desktopHeader: {
    height: "80px",
    backgroundColor: "#262728",
    borderBottom: "2px solid #1E1E1E",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  desktopHeaderContainer: {
    width: "90%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  desktopContainer: {
    backgroundImage: `url(${DesktopLoginBg}) !important`,
    backgroundSize: "cover",
    // position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "calc(100vh - 80px)",
    backgroundColor: "#262728",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 1s ease-in-out",
    zIndex: 10,
    // backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    overflow: "none",
  },
  mobileScreen: {
    height: "calc(100% - 32px)",
    width: "calc(100% - 32px)",
    position: "relative",
    padding: "16px",
  },
  desktopScreen: {
    height: "calc(90% - 80px)",
    width: "calc(60% - 80px)",
    maxWidth: "520px",
    maxHeight: "820px",
    position: "relative",
    background: "black",
    overflow: "hidden",
    borderRadius: "20px",
    padding: "40px",
  },
  formContainer: {
    position: "fixed",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100% !important",
    minHeight: "100vh !important",
    width: "100% !important",
    alignItems: "center",
  },
  copywrite: {
    fontSize: "14px !important",
    fontWeight: "500",
    color: "#8A8A8A",
    [theme.breakpoints.down("ultraHD")]: {
      fontSize: "10.5px !important",
    },
  },
  loginVector: {
    height: "330px",
    opacity: "0.1",
    [theme.breakpoints.down("md")]: {
      height: "230px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "130px",
    },
  },
  logo: {
    position: "absolute",
    top: "52%",
    [theme.breakpoints.down("ultraHD")]: { top: "42%" },
    left: "-7%",
    opacity: "10%",
    width: "661px",
    height: "661px",
    zIndex: 1,
  },
}));

const AuthLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {isMobile ? (
        <Box className={classes.container}>
          <Box className={classes.mobileScreen}>
            <Box sx={{ height: "40px" }}>
              <img
                src={Logo}
                style={{ height: "40px", width: "auto" }}
                alt=""
              />
            </Box>
            <Box sx={{ height: "calc(100% - 40px)" }}>{children}</Box>
          </Box>
        </Box>
      ) : (
        <Box className={classes.desktopLayout}>
          <Box className={classes.desktopHeader}>
            <Box className={classes.desktopHeaderContainer}>
              <img
                src={dskLogo}
                style={{ height: "40px", width: "auto" }}
                alt=""
              />
            </Box>
          </Box>
          <Box className={classes.desktopContainer}>
            <Box className={classes.desktopScreen}>{children}</Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default AuthLayout;
